import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  flex?: boolean;
};

export const Root = styled.div`
  width: calc(100% - 80px);
  padding: 40px 40px 40px 40px;
`;

export const Title = styled.div`
  padding: 0px 0px 26px 0px;
  font-family: Roboto;
  font-size: 25px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARK_BLUE};
`

export const TemplatesContainer = styled.div`
  margin: 45px 0px 0px 0px;
  width: 100%;
`

export const TemplatesWrap = styled.div`
  padding: 0px 8px 0px 0px;
  display: ${(props: IRootProps) => props.flex ? 'grid' : 'unset'};
  grid-template-columns: ${(props: IRootProps) => props.flex ? 'repeat(auto-fill, 230px)' : 'unset'};
  justify-content: ${(props: IRootProps) => props.flex ? 'space-between' : 'unset'};
`

export const AllLoaderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const NoTabTemplatesContainer = styled.div`
  width: 100%;
  height: 122px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 48px 0px 0px 0px;
`

export const TabEmptyIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 134px;
  height: 122px;
  margin: 0px 60px 0px 0px;
  overflow: hidden;
`

export const TabEmptyTextContainer = styled.div`
  font-family: Roboto;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARK_BLUE};
`

export const NoTemplatesContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 18px 0px 0px 0px;
`

export const EmptyIcon = styled.div`
  width: 460px;
  margin: 0px 78px 0px 0px;
`

export const EmptyTextContainer = styled.div`
`

export const EmptyTitle = styled.div`
  max-width: 455px;
  padding: 30px 0px 30px 0px;
  font-family: Roboto;
  font-size: 30px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.BLUE};
`

export const EmptySubtitle = styled.div`
  max-width: 455px;
  font-family: Roboto;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARK_BLUE};
`

export const LoaderContainer = styled.div`
`

export const EndContainer = styled.div`
`

export const UpsellContainer = styled.div`
  margin-top: 20px;
  width: 60%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 20px;
`;


export const UpsellTextContainer = styled.div`
  max-width: 600px;
`;

export const UpsellTitle = styled.h2`
  font-size: 28px;
  font-weight: bold;
  color: ${C.DARK_BLUE};
  margin-bottom: 15px;
`;

export const UpsellDescription = styled.p`
  font-size: 16px;
  color: ${C.DARK_BLUE};
  margin-bottom: 10px;
`;

export const BlurredContent = styled.div`
  flex-grow: 1;
  overflow: hidden;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    backdrop-filter: blur(3px);
    background: rgba(255,255,255,0.6);
    z-index: 2;
  }
`;

export const UpsellWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
`;



export const FeatureList = styled.ul`
  margin-top: 10px;
  padding-left: 20px;
  list-style-type: none;
`;

export const FeatureItem = styled.li`
  font-size: 16px;
  color: ${C.DARK_BLUE};
`;

export const UpsellCTA = styled.p`
  margin-top: 20px;
  font-size: 16px;
  color: ${C.DARK_BLUE};
`;

export const UpsellImageGallery = styled.div`
  display: flex;
  gap: 20px;
`;

export const ImageCard = styled.div`
  text-align: center;
  
  img {
    width: 150px;
    height: auto;
  }

  p {
    font-size: 14px;
    color: ${C.GRAY};
  }
`;